import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from './GlassCard';
import { SectionHeading } from './SectionHeading';
import { CheckCircle2, Quote } from 'lucide-react';
export function CEOSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-28">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary-blue/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-29" />

      <div className="container mx-auto px-6" data-id="element-30">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-31">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-32">
            <div className="aspect-[4/5] rounded-[40px] overflow-hidden border border-white/10 relative group" data-id="element-33">
              <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm1_img_666877698.png" alt="CEO Cyber Ready Security" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-34" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" data-id="element-35" />

              <div className="absolute bottom-8 left-8 right-8" data-id="element-36">
                <div className="text-2xl font-bold text-white mb-1" data-id="element-37">
                  Dr. Isaac Adeyemi
                </div>
                <div className="text-primary-blue font-medium text-sm" data-id="element-38">
                  Founder & CEO, Cyber Ready Security
                </div>
              </div>
            </div>

            {/* Credentials Badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -right-6" data-id="element-39">
              <GlassCard className="p-4 border-white/20" data-id="element-40">
                <div className="flex flex-col gap-2" data-id="element-41">
                  <div className="text-[10px] text-white/40 uppercase font-bold tracking-widest" data-id="element-42">
                    Credentials
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-43">
                    {['CISA', 'CISSP', 'CISM', 'PMP'].map(cred => <span key={cred} className="px-2 py-1 rounded bg-primary-blue/10 text-primary-blue text-[10px] font-bold border border-primary-blue/20" data-id="element-44">
                        {cred}
                      </span>)}
                  </div>
                </div>
              </GlassCard>
            </motion.div>
          </motion.div>

          <div className="space-y-8" data-id="element-45">
            <div className="inline-block p-3 rounded-2xl bg-white/5 text-primary-blue mb-2" data-id="element-46">
              <Quote size={32} fill="currentColor" className="opacity-20" data-id="element-47" />
            </div>

            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white leading-tight" data-id="element-48">
              Leading the Charge in <br data-id="element-49" />
              <span className="text-primary-blue" data-id="element-50">Cyber Resilience.</span>
            </h2>

            <p className="text-lg text-white/70 italic leading-relaxed" data-id="element-51">
              "Our mission is simple: to empower professionals with the elite
              skills required to protect global organizations in an increasingly
              complex threat landscape."
            </p>

            <div className="space-y-6" data-id="element-52">
              <p className="text-white/50 leading-relaxed" data-id="element-53">
                With over two decades of experience in enterprise security and
                governance, Dr. Isaac Adeyemi founded CRS to bridge the critical
                gap between academic theory and real-world security operations.
              </p>

              <div className="grid sm:grid-cols-2 gap-4" data-id="element-54">
                {['20+ Years Industry Experience', 'Global Security Consultant', 'Published Author & Speaker', 'Enterprise GRC Expert'].map(item => <div key={item} className="flex items-center gap-3 text-white/80" data-id="element-55">
                    <CheckCircle2 size={18} className="text-status-success" data-id="element-56" />
                    <span className="text-sm font-medium" data-id="element-57">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="pt-8 flex items-center gap-6" data-id="element-58">
              <button className="px-8 py-4 bg-primary-blue text-white font-bold rounded-full hover:bg-blue-600 transition-all" data-id="element-59">
                Read Founder's Story
              </button>
              <div className="flex flex-col" data-id="element-60">
                <img src="https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/main-logo.png" alt="Signature" className="h-8 w-auto opacity-50 grayscale brightness-200" data-id="element-61" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}